import * as React from 'react'
import { styled } from '@mui/material/styles'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import { Box, Divider, OutlinedInput } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const BootstrapInput = styled(OutlinedInput)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(3),
  },
  '& .MuiOutlinedInput-input': {
    padding: '9px 19px',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#E4E4E4',
    },
    '&:hover fieldset': {
      borderColor: '#04002E',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#3F69FF',
    },
  },
}))

interface DropdownWithPlaceholderProps {
  placeholder: string
  listItems: { id: string; name: string }[]
  disabled?: boolean
  required?: boolean
  handleSelect?: (selectedItem: string) => void
}

const DropdownWithPlaceholder: React.FC<DropdownWithPlaceholderProps> = ({
  listItems,
  placeholder,
  disabled,
  required,
  handleSelect,
}) => {
  const [selectedItem, setSelectedItem] = React.useState<string>('')

  const handleChange = (event: SelectChangeEvent<typeof selectedItem>) => {
    const {
      target: { value },
    } = event
    handleSelect?.(value)
    setSelectedItem(value)
  }

  const menuItems: React.ReactNode[] = []
  listItems.forEach((item, index) => {
    menuItems.push(
      <MenuItem
        key={`item-${index}`}
        value={item.id}
        sx={{
          padding: '11px 19px 9px 19px',
          fontSize: '14px',
          color: '#04002E',
          lineHeight: 'normal',
        }}
      >
        {item.name}
      </MenuItem>,
    )

    if (index < listItems.length - 1) {
      menuItems.push(
        <Box
          key={`divider-${index}`}
          sx={{
            mx: `${item.id === selectedItem ? 0 : '19px'}`,
          }}
        >
          <Divider sx={{ opacity: 0.6 }} />
        </Box>,
      )
    }
  })

  return (
    <div>
      <FormControl
        variant='outlined'
        disabled={disabled}
        sx={{
          width: '100%',
          boxShadow: '0px 3px 10px 0px rgba(187, 187, 187, 0.25)',
        }}
      >
        <Select
          required={required}
          displayEmpty
          value={selectedItem}
          onChange={handleChange}
          input={<BootstrapInput />}
          renderValue={(selected) => {
            if (!selected) {
              return placeholder
            }

            return listItems.find((item) => item.id === selected)?.name
          }}
          inputProps={{ 'aria-label': 'Without label' }}
          sx={{
            color: `${!selectedItem ? '#C3C3C3' : '#04002E'}`,
            fontSize: '14px',
            '& .MuiSvgIcon-root': {
              color: '#04002E',
            },
          }}
          MenuProps={{
            sx: {
              '&& .Mui-selected': {
                backgroundColor: '#EFEFEF',
              },
              '&& .Mui-selected: hover': {
                backgroundColor: '#EFEFEF',
              },
              '.MuiList-root': {
                padding: 0,
              },
            },
          }}
          IconComponent={ExpandMoreIcon}
        >
          {menuItems}
        </Select>
      </FormControl>
    </div>
  )
}

export default DropdownWithPlaceholder
